<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mr-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Outlet
        </v-card-title>
        <page-loader :loading="isFetching" />
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Name"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.brand"
                outlined
                label="Brand"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn v-can:edit="'monthly_bookings'"
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Outlet
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "OutletEditPage",
  data() {
    return {
      form: {
        is_active: false,
      },
      isLoading: false,
      isFetching: false,
    };
  },
  async mounted() {
    this.isFetching = true;
    try {
      await this.getData();
    } finally {
      this.isFetching = false;
    }
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.outletId;
      axios
        .get(`/outlets/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        await axios
          .patch(`/outlets/${this.$route.params.outletId}`, this.form)
          .then(async () => {
            await this.saveUserTimestamp(this.old_json, this.form);
            this.$router.push("/outlets");
          })
          .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
